"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const lodash_1 = require("lodash");
const customer_1 = require("../shared/models/customer/customer");
let CustomerSelectOverlayComponent = class CustomerSelectOverlayComponent {
    constructor(customer) {
        this.customer = customer;
        this.customerIdChange = new core_1.EventEmitter();
        this.customerChange = new core_1.EventEmitter();
        this.exit = new core_1.EventEmitter();
        this.showCustomerForm = false;
        this.editCustomerId = undefined;
        this.customers = null;
        this.selectedCustomer = null;
        this.query = '';
        this.getSearchResults = () => __awaiter(this, void 0, void 0, function* () {
            if (this.query.length < 4) {
                this.customers = null;
                return;
            }
            this.customers = yield this.customer.find(this.query);
        });
        this.find = (0, lodash_1.debounce)(this.getSearchResults, 500);
        this.selectCustomer = (customerId) => {
            var _a, _b;
            this.selectedCustomer = ((_a = this.customers) === null || _a === void 0 ? void 0 : _a.find((c) => c.id === customerId)) || null;
            this.customerIdChange.emit(((_b = this.selectedCustomer) === null || _b === void 0 ? void 0 : _b.id) || null);
            this.customerChange.emit(this.selectedCustomer);
        };
        this.deleteSelection = () => {
            this.selectedCustomer = null;
            this.customerIdChange.emit(null);
            this.customerChange.emit(null);
        };
        this.editCustomer = (customerId) => {
            this.openCustomerForm();
            this.editCustomerId = customerId;
        };
        this.openCustomerForm = () => {
            this.showCustomerForm = true;
            this.editCustomerId = undefined;
        };
        this.hideCustomerForm = () => {
            this.showCustomerForm = false;
        };
        this.customerUploaded = (c) => {
            this.selectedCustomer = c;
            this.customerIdChange.emit(c.id);
            this.customerChange.emit(c);
            this.hideCustomerForm();
        };
        this.closeOverlay = () => this.exit.emit();
    }
};
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", String)
], CustomerSelectOverlayComponent.prototype, "customerId", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", String)
], CustomerSelectOverlayComponent.prototype, "placeholder", void 0);
__decorate([
    (0, core_1.Output)(),
    __metadata("design:type", Object)
], CustomerSelectOverlayComponent.prototype, "customerIdChange", void 0);
__decorate([
    (0, core_1.Output)(),
    __metadata("design:type", Object)
], CustomerSelectOverlayComponent.prototype, "customerChange", void 0);
__decorate([
    (0, core_1.Output)(),
    __metadata("design:type", Object)
], CustomerSelectOverlayComponent.prototype, "exit", void 0);
CustomerSelectOverlayComponent = __decorate([
    (0, core_1.Component)({
        selector: 'customer-select-overlay',
        templateUrl: require('./overlay.component.html'),
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof customer_1.CustomerModel !== "undefined" && customer_1.CustomerModel) === "function" ? _a : Object])
], CustomerSelectOverlayComponent);
exports.default = CustomerSelectOverlayComponent;
